import { SuccessFeedbackScreen, ButtonPrimary, skinVars, useWindowSize } from '@telefonica/mistica';
import { t } from 'i18next';
import './index.scss';
import { useNavigate } from 'react-router-dom';

const FeedBackQREsim = () => {
    const size = useWindowSize();
    const navigate = useNavigate();
    const navigationUrl = '/configure-line/sim/installWithQr';

    return (
        <div
            className='feedbackQR-page__content'
            style={{ background: size.width < 1024 || size.height < 550 ? skinVars.colors.backgroundBrand : '' }}
        >
            <SuccessFeedbackScreen
                title={t('feedbackQrTitle')}
                description={t('feedbackQrDescription')}
                primaryButton={
                    <ButtonPrimary
                        onPress={() => {
                            navigate(navigationUrl);
                        }}
                    >
                        {t('continue')}
                    </ButtonPrimary>
                }
            ></SuccessFeedbackScreen>
        </div>
    );
};

export default FeedBackQREsim;
